var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2C16.4477 2 16 1.55228 16 1C16 0.447715 16.4477 0 17 0H23C23.5523 0 24 0.447715 24 1V7C24 7.55228 23.5523 8 23 8C22.4477 8 22 7.55228 22 7V3.41421L14.2071 11.2071C13.8166 11.5976 13.1834 11.5976 12.7929 11.2071L8.5 6.91421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L7.79289 4.79289C8.18342 4.40237 8.81658 4.40237 9.20711 4.79289L13.5 9.08579L20.5858 2H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphW);
export default __webpack_public_path__ + "static/media/graphW.646e94b0fa83b2fe08277775ed45f8d7.svg";
export { ForwardRef as ReactComponent };